import React, { useState, useEffect } from 'react';
import { PerfilService } from '../../services/PerfilService';
import { toast } from 'react-toastify';

const AsignarPermisos = ({ perfilId, perfilName, onClose, token }) => {
  const [permisos, setPermisos] = useState([]);
  const [permisosAsignados, setPermisosAsignados] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
    // Obtener todos los permisos
    getPermisos();
    getPermisosByPerfil();
  }, [perfilId]);

  const togglePermiso = (permisoId) => {
    setPermisosAsignados(prev =>
      prev.includes(permisoId)
        ? prev.filter(id => id !== permisoId)
        : [...prev, permisoId]
    );
  };

  const getPermisos = async () => {
    try {
      const response = await PerfilService.getPermisos(token);
      setPermisos(response)
    } catch (err) {
      setError("Error al guardar categoría");
    }
  };

  const getPermisosByPerfil = async () => {
    try {
      const response = await PerfilService.getPermisosByPerfil(token, perfilId);

      // Extraer solo los permiso_id
      const idsAsignados = response.map(p => p.permiso_id);

      setPermisosAsignados(idsAsignados)
    } catch (err) {
      setError("Error al guardar categoría");
    }
  };

  const guardarPermisos = async () => {
    try {
      const response = await PerfilService.guardarPermisos(token, { permisos: permisosAsignados }, perfilId);
      toast.success("Se asigno los permisos correctamente");
      onClose();
    } catch (err) {
      setError("Error al guardar perfil");
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-box">
        <div className="modal-header">
          <span>Asignar permisos al perfil {perfilName}</span>
          <button className="modal-close-btn" onClick={onClose}>
            ×
          </button>
        </div>
        <div className="modal-content">
          <ul className="permisos-list">
            {permisos.map(permiso => (
              <li key={permiso.id} className="permiso-item">
                <label className="permiso-label">
                  <input
                    type="checkbox"
                    className="checkbox-compact"
                    checked={permisosAsignados.includes(Number(permiso.id))}
                    onChange={() => togglePermiso(permiso.id)}
                  />
                  <div className="permiso-texto">
                    <span className="permiso-clave">{permiso.clave}</span>
                    <span className="permiso-descripcion">{permiso.descripcion}</span>
                  </div>
                </label>
              </li>
            ))}
          </ul>

          <div className="modal-buttons-compact">
            <button onClick={guardarPermisos} className="btn btn-primary-compact">
              Guardar
            </button>
            <button
              type="button"
              className="btn btn-secondary-compact"
              onClick={onClose}
            >
              Cancelar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AsignarPermisos; 
